import {createContext,ReactNode,useEffect,useReducer} from 'react'
// utils
import axios from '../../utils/axios'
// services
import { 
  login as auhtLogin,
  // register as authRegister 
  resetPassword as authResetPassword,
  newPassword as authNewPassword
} from '../../services/authService';
// @types
import { ActionMap, AuthContextType,AuthState, AuthUser } from '../../@types/authentication'

enum Types {
  Initial = 'INITIALIZE',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  // Register = 'REGISTER'
}

type JWTAuthPayload = {
  [Types.Initial]: {
    isAuthenticated: boolean;
    user: AuthUser;
    dashboardRules: any,
    userModules: any
  };
  [Types.Login]: {
    user: AuthUser;
    dashboardRules: any,
    userModules: any
  };
  [Types.Logout]: undefined;
  // [Types.Register]: {
  //   user: AuthUser;
  // };
};
  
export type JWTActions = ActionMap<JWTAuthPayload>[keyof ActionMap<JWTAuthPayload>];

const initialState: AuthState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  dashboardRules: null ,
  userModules: null
}

const AuthReducer = (state:AuthState,action:JWTActions) => {
  switch(action.type){
    case 'INITIALIZE':
      return {
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user,
        dashboardRules: action.payload.dashboardRules,
        userModules: action.payload.userModules
      };
    case 'LOGIN':
      return {
        ...state,
        isAuthenticated:true,
        user: action.payload.user,
        dashboardRules: action.payload.dashboardRules,
        userModules: action.payload.userModules
      }
    // case 'REGISTER':
    //   return {
    //     ...state,
    //     isAuthenticated:true,
    //     user: action.payload.user,
    //     dashboardRules: null,
    //     userModules:null
    //   }
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        dashboardRules: null,
        userModules:null
      }
    default:
      return state;
  }
}

const AuthContext = createContext<AuthContextType | null>(null);

function AuthProvider({children} : {children: ReactNode}){
  const [state,dispatch] = useReducer(AuthReducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      const json_user = window.localStorage.getItem('user');

      if(json_user) {
        const user = JSON.parse(json_user)
        const {dashboardRules, userModules} = gerRulesAndModules(user);

        dispatch({
          type: Types.Initial,
          payload: {
            isAuthenticated: true,
            user,
            dashboardRules,
            userModules
          }
        });
      } else {
        try {
          const accessToken = window.localStorage.getItem('accessToken');

          if (accessToken) {
            const response = await axios.get('/auth/user', {
              headers: {
                Authorization: 'Bearer ' + accessToken
              }
            });
  
            const { user } = response.data;
            const {dashboardRules, userModules} = gerRulesAndModules(user);
  
            dispatch({
              type: Types.Initial,
              payload: {
                isAuthenticated: true,
                user,
                dashboardRules,
                userModules
              }
            });
          } else {
            dispatch({
              type: Types.Initial,
              payload: {
                isAuthenticated: false,
                user: null,
                dashboardRules:null,
                userModules:null
              }
            });
          }            
        } catch (err) {
          console.error(err);
  
          dispatch({
            type: Types.Initial,
            payload: {
              isAuthenticated: false,
              user: null,
              dashboardRules:null,
              userModules:null
            }
          });
        }
      }
    };

    initialize();
  }, []);

  const login = (user:any, token:string) => {
    // Set JWT in local storage
    window.localStorage.setItem('accessToken',token);
    window.localStorage.setItem('user', JSON.stringify(user));

    const {dashboardRules, userModules} = gerRulesAndModules(user);

    dispatch({
      type: Types.Login,
      payload: {
        user,
        dashboardRules,
        userModules
      }
    })
  }

  const logout = async () => {
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('user');

    dispatch({
        type: Types.Logout
    })
  }

  const gerRulesAndModules = (user:AuthUser) => {
    if(user && user.rules) {
      const dashboardRules:any = {};
      const userModules:any = {};
      const {rules} = user
  
      for (let rule of rules) {
        if(rule.type == "dashboard") {
          let key = rule.key
          dashboardRules[key] = rule
    
          if(userModules[rule.module]) {
            userModules[rule.module]++
          } else 
            userModules[rule.module] = 1
        }
      }

      return {
        dashboardRules,
        userModules
      }
    } else {
      return {
        dashboardRules:null,
        userModules:null
      }
    }
  }

  const resetPassword = (email: string) => {
    authResetPassword(email);
  };

  const newPassword = (password:string, username:string, token:string) => {
    const response = authNewPassword(password, username, token);
    // return response;
  }
  
  return (
    <AuthContext.Provider value={{
      ...state,
      login,
      logout,
      resetPassword,
      newPassword
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export {AuthContext, AuthProvider};